import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { QuickLinkSignFormData } from '../../../../../../models/quick-link-sign-form-data';
import { QuickLink } from '../../../../../../models/quick-link';

@Component({
    selector: 'app-quicklink-sign-form',
    templateUrl: './sign-form.component.html',
    styleUrls: ['./sign-form.component.scss'],
    standalone: true
})
export class SignFormComponent implements OnInit {

    @ViewChild('submitForm') form: ElementRef;

    @Input() formData: QuickLinkSignFormData;
    @Input() quickLink: QuickLink;
    @Input() buttonText = 'Aufgabe öffnen';

    id: string;
    clicked = false;

    ngOnInit(): void {
        this.id = this.generateID();
    }

    isEduvidual(): boolean {
        return this.formData.url.indexOf('eduvidual') !== -1;
    }

    isYedo(): boolean {
        return this.formData.url.indexOf('sia.education') !== -1 || this.formData.url.indexOf('yedo.at') !== -1;
    }

    onSubmit(): void {
        this.form.nativeElement.submit();
        this.clicked = true;
        ($(`#${this.id}`).closest('.modal') as any).modal('toggle');
        $('html')
            .css('cursor', 'initial');

    }

    onIFrameLoad($event: Event): void {
        if (this.clicked) {
            if (this.quickLink.redirect) {
                const tab = window.open(this.quickLink.redirect, '_blank');
                tab.focus();
            }
        }
    }

    // https://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript
    private generateID(): string {
        let text = '';
        const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

        for (let i = 0; i < 5; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return text;
    }
}
